import { createWebHistory, createRouter } from "vue-router";
import Home from "./components/Home.vue";
import Login from "./components/Login.vue";
import Register from "./components/Register.vue";
// lazy-loaded
const Profile = () => import("./components/Profile.vue")
const SendMoney = () => import("./components/SendMoney.vue")
const SendBalance = () => import("./components/SendBalance.vue")
const Users = () => import("./components/User.vue")
const Transactions = () => import("./components/Transaction.vue")
const Balances = () => import("./components/Balance.vue")
const Create2FA = () => import("./components/Create2FA.vue")
const ChangePassword = () => import("./components/ChangePassword.vue")
const Proof = () => import("./components/Proof.vue")
const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/home",
    component: Home,
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/register",
    component: Register,
  },
  {
    path: "/proof/:id",
    component: Proof,
  },
  {
    path: "/register/:id",
    component: Register,
  },
  {
    path: "/profile",
    name: "profile",
    // lazy-loaded
    component: Profile,
  },
  {
    path: "/sendmoney",
    name: "SendMoney",
    // lazy-loaded
    component: SendMoney,
  },
  {
    path: "/sendbalance",
    name: "SendBalance",
    // lazy-loaded
    component: SendBalance,
  },
  {
    path: "/balance",
    name: "Balances",
    // lazy-loaded
    component: Balances,
  },
  {
    path: "/transaction",
    name: "Transactions",
    // lazy-loaded
    component: Transactions,
  },
  {
    path: "/users",
    name: "Users",
    // lazy-loaded
    component: Users,
  },
  {
    path: "/create2fa",
    name: "Create2FA",
    // lazy-loaded
    component: Create2FA,
  },
  {
    path: "/changepwd",
    name: "Trocar Senha",
    component: ChangePassword,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.beforeEach((to, from, next) => {
//   const publicPages = ['/login', '/register', '/home'];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem('user');

//   // trying to access a restricted page + not logged in
//   // redirect to login page
//   if (authRequired && !loggedIn) {
//     next('/login');
//   } else {
//     next();
//   }
// });

export default router;